import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import OverviewTable from 'component/Template/OverviewTable'
import { getTemplateAction } from 'slices/template'

const TemplatePageLayout: React.FC = () => {
	const templateParam = useParams()

	const { loading, singleTemplate } = useAppSelector(state => state.template)

	const dispatch = useAppDispatch()

	useEffect(() => {
		const { id } = templateParam
		if (id !== undefined) {
			dispatch(getTemplateAction(id))
		}
	}, [templateParam])

	const onStatusChange = (val: boolean) => {
		const { id } = templateParam
		if (val && id !== undefined) {
			dispatch(getTemplateAction(id))
		}
	}

	return (
		<OverviewTable
			data={singleTemplate}
			loading={loading}
			onStatusChange={onStatusChange}
		/>
	)
}

export default TemplatePageLayout
